export const sleep = (ms: number) => new Promise(res => setTimeout(res, ms))

export function* backoffSteps(
  start = 800,
  factor = 1.6,
  max = 60_000,
  jitter = 0.2,
) {
  let cur = start
  while (true) {
    const j = cur * jitter
    const withJitter = Math.round(cur + (Math.random() * 2 - 1) * j)
    yield Math.max(0, withJitter)
    cur = Math.min(max, Math.floor(cur * factor))
  }
}

export const makeRangeKey = (id: number, [s, e]: [string, string]) => `${id}:${s}~${e}`

export type Canceler = () => void
